import React, { useEffect, useState } from 'react';

import { Container, Paper } from '@mui/material';
import { observer } from 'mobx-react';

import { YesNoBtnRow } from '@infoods/lifebase-ui';
import classes from './NgzSelfBillingSetupCard.module.scss';
import { angularizeWithProviders } from '../../../../shared/providers';
import { StripeElementsProvider } from '../../../../shared/components/stripe';
import { SelfBillingSetupCardConfig } from '../../../interfaces/selfBillingStripe';
import { stripeService } from '../../../services/stripeService';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { StripeSaveCardForm } from './StripeSaveCardForm/StripeSaveCardForm';
import { logout } from '../../../../shared/utils/userInfoUtils/logout/logout';

const formId = 'stripe-set-card-form-id';

const NgzSelfBillingSetupCard = observer(() => {
  const [stripeConfig, setStripeConfig] = useState<SelfBillingSetupCardConfig | null>(
    null,
  );

  const getConfig = async () => {
    const entityId = loggedInUserDataStore.getEntityId();

    if (!entityId) {
      throw new Error('Entity ID is not found');
    }

    const config = await stripeService.getSelfBillingSetupInitialCardConfig(entityId);

    setStripeConfig(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  if (!stripeConfig) {
    return null;
  }

  return (
    <Container className={classes.container}>
      <Paper variant="roundedBox" className={classes.box}>
        <div className={classes.titleBlock}>
          <h3 className={classes.title}>Add Card</h3>
          <p className={classes.description}>
            On this date each month, you will be billed for the number of active users
            (except free seats)
          </p>
        </div>
        <StripeElementsProvider
          publishableKey={stripeConfig.publishableKey}
          elementsOptions={{
            clientSecret: stripeConfig.clientSecret,
          }}
        >
          <StripeSaveCardForm formId={formId} />
        </StripeElementsProvider>
        <YesNoBtnRow
          yesText="Confirm"
          formId={formId}
          noText="Log out"
          noHandler={() => logout()}
          size="medium"
        />
      </Paper>
    </Container>
  );
});

angularizeWithProviders(NgzSelfBillingSetupCard, 'ngzSelfBillingSetupCard', {});

export { NgzSelfBillingSetupCard };
